import React from 'react'
import { Image, Modal, Header, Ref } from 'semantic-ui-react'

const ForwardedImage = React.forwardRef((props, ref) => (
  <Ref innerRef={ref}>
    <Image {...props} />
  </Ref>
))

const Images = ({ data }) => {
  return (
    <Image.Group size="small">
      {data.map(img => (
        <Modal
          key={img.url}
          trigger={
            <ForwardedImage
              src={img.url}
              alt={img.title}
              as="a"
              css={{
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
            />
          }
          basic
          closeIcon
          closeOnDocumentClick
        >
          <Header content={img.title} />
          <Modal.Content>
            <ForwardedImage src={img.url} alt={img.title} centered />
          </Modal.Content>
        </Modal>
      ))}
    </Image.Group>
  )
}

export default Images
